import { render, staticRenderFns } from "./SuperHeroCtaMobile.vue?vue&type=template&id=f9bbc7a2&scoped=true"
var script = {}
import style0 from "./SuperHeroCtaMobile.vue?vue&type=style&index=0&id=f9bbc7a2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9bbc7a2",
  null
  
)

export default component.exports